<template>
    <b-row>
        <b-col cols="12" class="py-5">
            <h3>¿Conoces algún abonado?</h3>
            <h5>Introduce aquí su número de abonado para activar la promoción</h5>
            <template v-if="! promocion_confirmada">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="buscarReferido()">
                    <div class="input-group">
                        <input class="form-control w-auto" id="input-referidos" v-model="n_abonado" :placeholder="$t('formularios.numero_abono')"/>
                        <button class="button large-button" :disabled="desactivar || !canSubmit" type="submit">Verificar</button>
                    </div>
                    <FormCaptchaComponent
                        ref="captcha"
                        :siteKey="sitekey"
                        @success="onCaptchaVerified"
                        @expired="onCaptchaInvalidHandler"
                        @error="onCaptchaInvalidHandler"
                    />
                </ValidationObserver>
            </template>
            <template v-else>
                <div class="input-group">
                    <input class="form-control w-auto" id="input-referidos" v-model="n_abonado" :placeholder="$t('formularios.numero_abono')" disabled/>
                    <button class="button large-button" style="background-color: #80bf78;"><i class="fa fa-check-circle"></i></button>
                </div>
            </template>            
            <b-modal 
                v-if="abonado" 
                id="abonado-modal" 
                title="Datos del abonado" 
                centered
                @ok="confirmarAbonadoHandler()"
                @cancel="cancelarHandler()"
            >
                <b-row>
                    <b-col cols="12">
                        <ul>
                            <li>Nombre: {{ abonado.name }} {{ abonado.surnames }}</li>
                        </ul>
                    </b-col>
                    <b-col cols="12" class="text-center">
                        <h3>¿Es correcto este abonado?</h3>
                    </b-col>
                </b-row>
            </b-modal>
        </b-col>
    </b-row>
</template>

<script setup>
    import { ref, getCurrentInstance } from 'vue';
    import { useBuscarReferidos } from '@/composables/front/abonos/useBuscarReferidos';
    import FormCaptchaComponent from '@/modules/ui/FormCaptchaComponent.vue';

    defineProps({
        session_id: { type: String, default: null },
        desactivar: { type: Boolean, default: false }
    });

    const instance = getCurrentInstance();

    const captcha = ref(null);
    const observer = ref(null);

    const {
        n_abonado,
        abonado,
        promocion_confirmada,
        loading,
        sitekey,
        canSubmit,
        onCaptchaVerified,
        onCaptchaInvalid,
        resetCaptcha,
        buscar,
        confirmarAbonado,
        cancelar
    } = useBuscarReferidos();

    // Centralised invalidation: clear the token AND hand the user a fresh
    // challenge, preserving the visible feedback (keepFeedback). Without the
    // widget reset, a hard error leaves the button disabled with no recovery.
    const onCaptchaInvalidHandler = () => {
        onCaptchaInvalid();
        captcha.value?.reset({ keepFeedback: true });
    };

    const buscarReferido = async() => {
        const isValid = await observer.value.validate();
        if (!isValid) return;

        const res = await buscar();
        if (res.ok) {
            setTimeout(() => {
                instance.proxy.$bvModal.show('abonado-modal');
            }, 200);
        } else {
            instance.proxy.$toast.error('Abonado no encontrado');
            // The backend consumed the token: clear it AND hand the user a
            // fresh challenge, or canSubmit stays true with a stale token.
            resetCaptcha(captcha.value);
        }
    };

    const confirmarAbonadoHandler = async() => {
        const res = await confirmarAbonado(instance.proxy.session_id, captcha.value);
        if (!res.ok) {
            instance.proxy.$toast.error('No se ha podido confirmar el abonado');
        }
    };

    const cancelarHandler = () => {
        // Full captcha lifecycle: a cancelled flow must not leave a reusable
        // token behind — the next search needs a fresh challenge.
        resetCaptcha(captcha.value);
        cancelar();
    };
</script>
